import React from "react";
import PrintSafesMain from "../PrintSafesMain";

export default function ReviewTransfers(props) {
    return (
        <div>
            <PrintSafesMain  typePrint={3} docNamePdf={"ReviewItems.pdf"} docName={"ReviewItems"}/>
        </div>
    );
}